<template lang="html">
  <div class="VideosList">
      <VideoSnippet
        v-for="video in videos" :key="video.id"
        :video='video'
      />
  </div>
</template>

<script>
import VideoSnippet from '@/components/VideoSnippet'
import { mapGetters } from 'vuex'

export default {
  name: 'VideosList',
  components: {
    VideoSnippet
  },
  props: ['videos'],
  computed: {
    ...mapGetters([
      // 'videoByID',
    ]),
  }
}
</script>

<style lang="css" scoped>
.VideosList {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
</style>
